import { env } from 'env';
import React from 'react';

import Button, { ButtonProps } from './Button';

const TakeMeHomeButton = (props: ButtonProps) => {
  const handleClick = () => {
    window.location.href = `${env.REACT_APP_REPUBLIC_FINANCE_HOME_PAGE}`;
  };

  return (
    <Button {...props} onClick={handleClick}>
      Take Me Home
    </Button>
  );
};

export default TakeMeHomeButton;
